module.exports = __webpack_public_path__ + "img/88_thumb.4fb6439d.gif";